import React, { useEffect } from 'react';
import { useResolvedPath, useMatch, Routes, Route, useNavigate, useParams } from 'react-router-dom';
import { PageLayoutProps } from '../../../../shared/menu-component';
import { FilesContainer } from './components/files.container';
import { ChatPageContainer } from './components/chat-page.container';
import { TransactionsContainer } from './components/transactions.container';
import { ActivityLogContainer } from './components/activity-log.container';
import { CaseDetailsApplicationContainer } from './components/case-details-application.container';
import { CasesSendReportV1IndexContainerStaffUserFieldsFragment } from '../../../../../generated';
import { CaseHistoryContainer } from './components/case-history.container';
import { ActiveCaseSummary } from './pages/active-summary';

interface SendReportProps {
  staffUserData: CasesSendReportV1IndexContainerStaffUserFieldsFragment;
  isApplicantSection?: boolean;
}

const SendReport: React.FC<SendReportProps> = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const chatRoutePath = useResolvedPath('chat');
  const applicationRoutePath = useResolvedPath('application');
  const filesRoutePath = useResolvedPath('files');
  const transactionsRoutePath = useResolvedPath('transactions');
  const activityLogRoutePath = useResolvedPath('activity-log');
  const caseHistoryRoutePath = useResolvedPath('case-history');

  const pathFromUrl: string = window.location.pathname.split('/')[2];
  const isCaseOrApplicant: string = pathFromUrl == 'cases' ? 'Cases' : 'Applicants';

  // redirect to (default) Chat if a case is selected
  const rootRoutePath = useResolvedPath('');
  const match = useMatch(rootRoutePath.pathname);
  useEffect(() => {
    if (match) {
      navigate('chat');
    }
  }, [match]);

  const pageLayouts: PageLayoutProps[] = [
    {
      path: chatRoutePath.pathname,
      title: 'Applicant Messages',
      icon: <></>,
      id: 'ROOT'
    },
    {
      path: applicationRoutePath.pathname,
      title: 'Application',
      icon: <></>,
      id: 'application',
      parent: 'ROOT'
    },
    {
      path: filesRoutePath.pathname,
      title: 'Files',
      icon: <></>,
      id: 'files',
      parent: 'ROOT'
    },
    {
      path: transactionsRoutePath.pathname,
      title: 'Transactions',
      icon: <></>,
      id: 'transactions',
      parent: 'ROOT'
    },
    {
      path: activityLogRoutePath.pathname,
      title: 'Activity Log',
      icon: <></>,
      id: 'activity-log',
      parent: 'ROOT'
    },
    ...(props?.staffUserData?.role?.permissions?.sendCasePermissions?.canViewCaseHistory
      ? [
          {
            path: caseHistoryRoutePath.pathname,
            title: 'Case History',
            icon: <></>,
            id: 'case-history',
            parent: 'ROOT'
          }
        ]
      : [])
  ];

  return (
    <div>
      <Routes>
        <Route path="" element={<ActiveCaseSummary pageLayouts={pageLayouts} caseId={params.caseId ?? ''} isApplicantSection={props.isApplicantSection} />}>
          <Route path="chat" element={<ChatPageContainer caseId={params.caseId ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="application" element={<CaseDetailsApplicationContainer caseId={params.caseId ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="files" element={<FilesContainer caseId={params.caseId ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="transactions" element={<TransactionsContainer caseId={params.caseId ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="activity-log" element={<ActivityLogContainer caseId={params.caseId ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          {props?.staffUserData?.role?.permissions?.sendCasePermissions?.canViewCaseHistory && (
            <Route path="case-history" element={<CaseHistoryContainer caseId={params['caseId'] ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          )}
        </Route>
      </Routes>
    </div>
  );
};

export default SendReport;
